var _path, _path2, _path3, _path4, _path5, _circle, _circle2, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoversconnectLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 704,
    height: 469,
    viewBox: "0 0 704 469",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M260 389C169 322 96 264 96 177C96 107 151 58 220 65C278 71 318 111 342 153C367 110 412 69 476 65C548 60 608 112 608 184C608 272 523 335 390 427C374 438 353 437 338 424C315 404 289 385 260 389Z",
    fill: "#ff1724"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M344 153C381 91 453 62 524 85C479 85 433 105 402 141C375 173 360 219 387 252C397 264 411 271 426 272C419 285 407 294 392 298C369 304 348 294 337 274C319 242 321 195 344 153Z",
    fill: "#d9101c",
    opacity: 0.45
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M362 99C420 46 512 51 570 107C628 163 626 254 566 312C521 356 468 388 401 432C388 441 371 441 358 433C463 352 539 292 546 208C552 130 493 80 424 89C400 92 379 99 362 99Z",
    fill: "#d80f1a",
    opacity: 0.55
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M327 382C314 357 318 321 343 286C363 258 383 244 381 220C379 195 358 175 331 170C285 161 232 172 195 202C214 148 264 111 322 117C377 123 422 162 436 214C444 245 437 276 417 297C399 317 372 327 343 323C334 342 333 364 344 386C339 385 333 383 327 382Z",
    fill: "#b70d16",
    opacity: 0.35
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M335 217C361 220 383 241 389 267C397 301 373 332 340 340C310 347 282 329 275 300C268 270 286 233 311 221C318 218 326 216 335 217Z",
    fill: "#ff1724"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 269,
    cy: 373,
    r: 56,
    fill: "#ff1724"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 269,
    cy: 373,
    r: 45,
    fill: "#ef1320"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M433 171C468 190 488 228 482 267C478 292 463 314 441 327C458 296 454 267 434 243C418 224 414 194 433 171Z",
    fill: "#8e0b13",
    opacity: 0.35
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M439 153C411 181 411 221 435 252C449 270 449 293 433 309C462 302 484 278 489 247C496 205 477 172 439 153Z",
    fill: "#ff3340"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M438 157C407 184 402 226 430 257C442 270 440 288 426 301C445 299 462 286 471 267C485 235 474 188 438 157Z",
    fill: "#c60e18",
    opacity: 0.55
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoversconnectLogo);
export default __webpack_public_path__ + "static/media/loversconnect-logo.b18aa3c40df0ea1b07c0ffdfdd796d74.svg";
export { ForwardRef as ReactComponent };